import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { LoadingStore } from 'ducks';
import { AnalyticsAPI } from 'api';
import { useDispatch, useSelector } from 'react-redux';
import { makeDateList, makeMonthFilter } from 'lib/date';
import {
  Container,
  Section,
  PageHeader,
  SankeyChart,
  MonthFilter,
} from '../components';
import Toolkit from '../../../components/Toolkit';

// const stats = [
//   {
//     "key": "distance_km",
//     "value": "Distance travelled (KM)",
//   },
// ]

const CrossLocationStats = ({ dateRange }) => {
  const dispatch = useDispatch();
  const { min: minDate, max: maxDate } = dateRange;
  const [data, setData] = useState(null);
  const dateList = makeDateList(minDate, maxDate);
  const [date, setDate] = useState(dateList[0]);
  // const [stat, setStat] = useState(stats[0]);

  const clientId = useSelector((state) => state.clients.selectedItemId);

  React.useEffect(() => {
    const fetchData = async (date) => {
      dispatch(LoadingStore.loading(true));
      try {
        const queryParams = makeMonthFilter(date);
        const response = await AnalyticsAPI.getCrossSuburbStats(clientId, queryParams);
        setData(response.payload);
      } catch (err) {
        console.error(err);
        setData(null);
      } finally {
        dispatch(LoadingStore.loading(false));
      }
    };
    fetchData(date);
  }, [date, clientId, dispatch]);

  return (
    <Container>
      <PageHeader
        title="Cross location stats"
        subtitle="Breakdown of activity statistics across start and end locations of trips"
      />
      <Toolkit>
        <MonthFilter
          label="Select month:"
          filter={{ date: date }}
          onFilterChanged={setDate}
          dateList={dateList}
        />
      </Toolkit>
      <Section fullHeight>
        <SankeyChart data={data} />
      </Section>
    </Container>
  );
};

CrossLocationStats.propTypes = {
  dateRange: PropTypes.object.isRequired,
};

export default CrossLocationStats;
